/* eslint-disable no-underscore-dangle */
import {
	useInfiniteQuery,
	useMutation,
	useQuery,
	useQueryClient,
} from 'react-query';
import { AxiosError, AxiosResponse } from 'axios';
import request from 'src/utils/request';

/// //////////////////////////////////////////////////
/// /////////////////   APIs   ///////////////////////
/// //////////////////////////////////////////////////

const getTransactions = async (page: number) => {
	const { data } = await request.get('/transactions', { page });
	return data;
};

const getTransactionsTags = async () => {
	const { data } = await request.get('/transactions/tags');
	return data;
};

const getReports = async () => {
	const { data } = await request.get('/transactions/report');
	return data;
};

const getReportsByTags = async () => {
	const { data } = await request.get('/transactions/reportByTags');
	return data;
};

const removeTransaction = async (transactionID: string) => {
	const { data } = await request.post(`/transaction/${transactionID}/delete`);
	return data;
};

const addTransaction = async (transaction: any) => {
	const { data } = await request.post('/transaction/create', transaction);
	return data;
};

// Reserved for useUpdateTransaction hook
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const updateTransaction = async (
	transactionData: any,
	transactionID: string,
) => {
	const { data } = await request.put(
		`/app/${transactionID}`,
		transactionData,
	);
	return data;
};

/// //////////////////////////////////////////////////
/// /////////////////  Hooks  ////////////////////////
/// //////////////////////////////////////////////////

const useTransactions: any = () => {
	return useInfiniteQuery<AxiosResponse | any, AxiosError>(
		'transactions',
		({ pageParam = 1 }) => getTransactions(pageParam),
		{
			getNextPageParam: (lastPage) => {
				if (
					lastPage?.pagination?.currentPage <
					lastPage?.pagination?.totalPages
				) {
					return lastPage?.pagination?.currentPage + 1;
				}
				return null;
			},
		},
	);
};

const useTransactionsTags: any = () => {
	return useQuery<AxiosResponse, AxiosError>(
		'transactionsTags',
		getTransactionsTags,
	);
};

const useReports: any = () => {
	return useQuery<AxiosResponse, AxiosError>('reports', getReports);
};

const useReportsByTags: any = () => {
	return useQuery<AxiosResponse, AxiosError>(
		'reportsByTags',
		getReportsByTags,
	);
};

const useDeleteTransaction: any = () => {
	const queryClient = useQueryClient();

	return useMutation<AxiosResponse, AxiosError, any, () => void>(
		removeTransaction,
		{
			onSuccess: (resData, transactionID) => {
				const data = (
					queryClient.getQueryData('transactions') as any
				).data.filter((item: any) => item._id !== transactionID);
				const transactions = queryClient.getQueryData(
					'transactions',
				) as any;
				queryClient.setQueryData('transactions', {
					...transactions,
					data,
				});
			},
		},
	);
};

const useAddTransaction: any = () => {
	return useMutation<AxiosResponse, AxiosError, any, () => void>(
		addTransaction,
	);
};

// const useUpdateTransaction: any = () => {
// 	const queryClient = useQueryClient();

// 	return useMutation<AxiosResponse, AxiosError, any, () => void>(
// 		updateTransaction,
// 		{
// 			onSuccess: (resData) => {
// 				queryClient.setQueryData('transactions', resData);
// 			},
// 		},
// 	);
// };

export {
	useTransactions,
	useTransactionsTags,
	useDeleteTransaction,
	useAddTransaction,
	useReports,
	useReportsByTags,
	// useUpdateTransaction,
};
